/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgObjectC = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16 5a3 3 0 1 1 1.714 2.711L16 9.426v2.858a5.64 5.64 0 0 0-1.685 1.947 6.283 6.283 0 0 0-.62 1.769H9.402l-1.7 1.699a3 3 0 1 1-1.418-1.41L8 14.574V9.426L6.286 7.71A3 3 0 1 1 7.704 6.3L9.403 8h5.194l1.7-1.699A2.99 2.99 0 0 1 16 5zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-5 6h-4v4h4zM5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm17.26 3.652v-1.56c-.456.16-.86.28-1.212.36a4.969 4.969 0 0 1-1.02.108c-.84 0-1.476-.26-1.908-.78-.432-.528-.648-1.276-.648-2.244 0-.896.22-1.588.66-2.076s1.072-.732 1.896-.732c.288 0 .584.032.888.096.312.064.68.176 1.104.336v-1.584c-.272-.136-.588-.248-.948-.336s-.752-.132-1.176-.132c-.896 0-1.668.18-2.316.54a3.627 3.627 0 0 0-1.5 1.524c-.352.656-.528 1.444-.528 2.364 0 1.496.36 2.644 1.08 3.444.72.792 1.78 1.188 3.18 1.188a5.49 5.49 0 0 0 1.356-.156c.416-.096.78-.216 1.092-.36z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgObjectC as ObjectC };
